var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main"},[_c('fade-animation',[_c('common-gallary',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"imgs":_vm.url}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }